// @负责人: xiehan
// @创建时间: 2018-03-12
// @版本: v1.0.13
// @描述: 视图配置过滤数据属性
export default class DataHelper {
  filterObj = {};
  stackName = '';
  filterDataList = [];

  propertyCount = 0;
  propertyNum = 0;

  filterKpiData (obj) {
    // 固定 data 开头
    const res = {}
    if (obj && obj[0]) {
      for (const key in obj[0]) {
        res[`data.${key}`] = `data.${key}`
      }
    }
    return res
  }

  filterData (obj) {
    this.filterObj = {}
    this.propertyNum = Object.keys(obj).length
    for (let i in obj) {
      this.stackName = ''
      this.objCount = 0
      this.getEachPropertyName(obj, i)
    }
    for (let i in this.filterObj) {
      if (!this.checkAvailable(obj, i)) {
        delete this.filterObj[i]
      }
    }
  }

  getEachPropertyName (obj, i) {
    this.propertyCount++
    this.filterObj[this.stackName + i] = this.stackName + i
    if (this.propertyCount === this.propertyNum) {
      this.stackName = this.resetStackName(this.stackName, i)
      this.propertyCount = this.propertyNum = 0
      for (let j in this.filterObj) {
        if (j.indexOf('.') !== -1) {
          j = j.split('.')[j.split('.').length - 1]
        }
        if (!this.checkAvailable(obj, j)) {
          if (obj[j] instanceof Object && !Array.isArray(obj[j])) {
            this.propertyNum = Object.keys(obj[j]).length
            this.stackName = this.stackName + j + '.'
            for (let k in obj[j]) {
              this.getEachPropertyName(obj[j], k)
            }
          } else if (Array.isArray(obj[j]) && obj[j][0] instanceof Object) {
            this.propertyNum = Object.keys(obj[j][0]).length
            this.stackName = this.stackName + j + '.'
            for (let k in obj[j][0]) {
              this.getEachPropertyName(obj[j][0], k)
            }
          }
        }
      }
    }
  }

  // 当stackName中有.时，当前对象赋值完毕重置stackName。
  resetStackName (name, i) {
    let str = name + i
    let splitArr = str.split('.')
    return str.substring(0, str.indexOf(splitArr[1]))
  }

  // 检查当前属性是否是可用数据(非空或者是可用的数字、字符串、布尔值)。
  checkAvailable (data, name) {
    const nameArr = name.split('.')
    let filterObj = data
    let isTrue = false
    nameArr.map((item, index) => {
      if (filterObj[item] instanceof Array) {
        filterObj = filterObj[item][0]
      } else if (filterObj[item] instanceof Object) {
        filterObj = filterObj[item]
      } else if ((typeof filterObj[item] === 'string' || typeof filterObj[item] === 'number' || typeof filterObj[item] === 'boolean')) {
        isTrue = true
      }
    })
    return isTrue
  }

  filterDataByName (data, name) {
    this.filterDataList = []
    try {
      const nameArr = name.split('.')
      let filterObj = { ...data }
      nameArr.map((item, index) => {
        if (filterObj[item] instanceof Array) {
          filterObj[item].map((_item) => {
            this.filterDataList.push(_item[nameArr[index + 1]])
          })
        } else if (filterObj[item] instanceof Object) {
          filterObj = { ...filterObj[item] }
        } else if ((typeof filterObj[item] === 'string' || typeof filterObj[item] === 'number' || typeof filterObj[item] === 'boolean')) {
          this.filterDataList.push(filterObj[item])
        }
      })
    } catch (e) {
      console.error('check data type')
    }
  }

  getFilterObj () {
    return this.filterObj
  }

  getFilterDataList () {
    return this.filterDataList
  }
}
